import { useBillMatchedItemListPresenter } from './useBillMatchedItemListPresenter'
import { BillMatchedItemsTable } from '../../views/BillMatchedItemsTable'

export interface IBillMatchedItemListPresenterProps {
  sessionId: number
}

export const BillMatchedItemListPresenter = ({
  sessionId,
}: IBillMatchedItemListPresenterProps) => {
  const {
    data: { matches, totalCost },
    states: { isLoading },
  } = useBillMatchedItemListPresenter({ sessionId })

  // Card currency derived from the matched items (feature receives only the
  // session id).
  const currencyName = matches[0]?.creditcardItems[0]?.currency.name ?? ''

  return (
    <BillMatchedItemsTable
      matches={matches}
      totalCost={totalCost}
      currencyName={currencyName}
      isLoading={isLoading}
    />
  )
}

BillMatchedItemListPresenter.displayName = 'BillMatchedItemListPresenter'
